import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { OktaAuth } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import { toRelativeUrl } from '@okta/okta-auth-js'; 

// Styles
import 'semantic-ui-css/semantic.min.css';
import "./styles/main.css";
// import './styles/dark.css';

// Configurations
import './configuration/polyfills';
import oktaconfig from './configuration/oktaconfig';

// Applicaton
import App from './App';

const oktaAuth = new OktaAuth(oktaconfig.oidc);

// Adjusted restoreOriginalUri function for React Router v5
const restoreOriginalUri = async (_oktaAuth, originalUri) => {
  const relativeUri = toRelativeUrl(originalUri || '/', window.location.origin);
  
  console.log(relativeUri);

  // Navigate using React Router's history
  if (_oktaAuth && _oktaAuth.history) {
    _oktaAuth.history.replace(relativeUri); // Using history.replace to prevent additional entries in history stack
  } else {
    // Fallback if history is not available
    window.location.assign(relativeUri);
  }
};


// After upgrade to React 18
const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<Router basename={oktaconfig.app.basename}>
  <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
    <App />
  </Security>
</Router>);
